import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const NavigationButtons = ({ 
  currentStep, 
  totalSteps, 
  prevStep, 
  nextStep, 
  backToReview, 
  hasCompletedOnce, 
  isEditingFromReview 
}) => {
  return (
    <div className="w-full max-w-md mt-8 flex justify-between">
      <button 
        onClick={prevStep}
        className="flex items-center justify-center px-6 py-3 rounded-lg bg-gray-200 hover:bg-gray-300 transition-colors duration-300 text-gray-700"
      >
        <ChevronLeft size={18} className="mr-2" />
        上一步
      </button>
      
      {/* Show "Back to Review" button if user came from review page */}
      {hasCompletedOnce && isEditingFromReview && (
        <button 
          onClick={backToReview}
          className="flex items-center justify-center px-6 py-3 rounded-lg bg-blue-100 hover:bg-blue-200 transition-colors duration-300 text-blue-700"
        >
          回到回顾
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
          </svg>
        </button>
      )}
      
      <button 
        onClick={nextStep}
        className="flex items-center justify-center px-6 py-3 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-400 hover:to-indigo-500 transition-all duration-300 text-white font-medium shadow-md hover:shadow-lg"
      >
        {currentStep === totalSteps ? '完成' : '下一步'}
        <ChevronRight size={18} className="ml-2" />
      </button>
    </div>
  );
};

export default NavigationButtons;